import * as types from "./mutation-types";

export const mutations = {
    [types.UPDATE_LOADING_BRANCHEN](state, payload) {
        state.loadingBranchen = payload;
    },
    [types.UPDATE_ERROR_BRANCHEN](state, payload) {
        state.errorBranchen = payload;
    },
    [types.UPDATE_BRANCHEN](state, payload) {
        state.branchen = payload;
    }
}